import axios from 'axios'
import qs from 'qs'
import {Message} from 'element-ui'
import { API_BASE_URL } from '@/config'

axios.defaults.withCredentials = false;

let baseUrl = API_BASE_URL + '/'
var instance = axios.create({
        baseURL : baseUrl   //以后要改主机或端口, 只要改这里
    }
)

instance.interceptors.request.use(
    config => {
        let token = window.sessionStorage.getItem('token');
        if (token!=null) {
            config.headers.Authorization = "bearer " + token;
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
);

instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    Message.error({message:  '你没有权限，请重新登录', offset: 150});
                    window.sessionStorage.removeItem('token');
                    // router.push('/login');	 //跳转登录
                    break;
                case 403:   //禁止访问
                    Message.error({message: '禁止访问,请登录', offset: 150});
                    window.sessionStorage.removeItem('token');
                    // router.push('/login');	 //跳转登录
            }
        }
        if(error.response.data.error=="invalid_grant" && error.response.data.error_description=="用户名或密码错误"){
            console.log("冻结")
            Message.error({message: "密码错误", offset: 150});

        }
        return Promise.reject(error.response.data)   // 返回接口返回的错误信息
    }
);

// url = '/api/....' params  JS对象
export let $get = (url, params) => {
    return instance.get(url, {
        params : params
    })
}

// data 参数是js对象 , SpringBoot 参数接收 @RequestBody类
// data 参数是js数组 , SpringBoot 参数接收 @RequestBody List<类>
export let $postJson = (url,data) => {
    return instance.post(url, data)
}

//data: JS 对象   转成 x-www-form-urlencoded 发送到 SpringBoot, 用普通参数接收
export let $postX = (url, data) => {
    //console.log(data)
    //JS 对象 ==> id=123&username=tom&
    let strKV = qs.stringify(data)
    //console.log(strKV)
    return instance.post(
        url, strKV,
        {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        })
}

// 文件上传, formData 格式, multipart/form-data
// formData 是 new FormData
export let $postFile = (url, formdata) => {
    return instance.post(url, formdata, {'Content-Type':'multipart/form-data'})
}
